<div class="icon-{{ id }}{{ className ? ' ' + className : '' }}">
  <svg xmlns="http://www.w3.org/2000/svg">
    <use attr.xlink:href="#icon-{{ id }}" />
  </svg>
</div>
